import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'

const styles = () => ({
  bar: {
    display: 'flex',
    alignItems: 'center',
    gap: 'var(--careco-space-sm)',
    flexWrap: 'wrap',
    marginBottom: 'var(--careco-space-md)',
    fontFamily: 'var(--careco-font)',
  },
  search: {
    width: 320,
    maxWidth: '100%',
  },
  spacer: { flex: 1 },
  count: {
    fontSize: 14,
    color: 'var(--careco-text-secondary)',
    whiteSpace: 'nowrap',
    fontVariantNumeric: 'tabular-nums',
    marginLeft: 'auto',
  },
  countStrong: {
    fontWeight: 700,
    color: 'var(--careco-text-primary)',
  },
  clear: {
    height: 38,
    padding: '0 var(--careco-space-sm)',
    background: 'transparent',
    border: 'none',
    borderRadius: 'var(--careco-rounded-sm)',
    color: 'var(--careco-primary)',
    fontFamily: 'var(--careco-font)',
    fontSize: 14,
    fontWeight: 600,
    cursor: 'pointer',
    '&:hover': { background: 'var(--careco-row-default)' },
    '&:focus-visible': {
      outline: '2px solid var(--careco-primary)',
      outlineOffset: 2,
    },
  },
  filters: {
    display: 'contents',
  },
  trailing: {
    display: 'contents',
  },
  '@media (max-width: 600px)': {
    bar: {
      alignItems: 'stretch',
    },
    search: {
      width: '100%',
    },
    spacer: {
      display: 'none',
    },
    filters: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: 'var(--careco-space-sm)',
      width: '100%',
    },
    trailing: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: 'var(--careco-space-sm)',
      width: '100%',
    },
    count: {
      width: '100%',
      textAlign: 'right',
    },
  },
})

const FilterBar = ({
  classes,
  search,
  filters,
  total,
  shown,
  itemNoun = 'record',
  itemNounPlural,
  onClear,
  trailing,
}) => {
  const isNarrowed = shown != null && total != null && shown !== total
  // Callers pass onClear only when filters are active (see Professionals /
  // ServiceUsers). Do not require shown !== total — server-paged filters make
  // those counts equal once the API has already narrowed the result set.
  const showClear = Boolean(onClear)
  const plural = itemNounPlural || `${itemNoun}s`

  return (
    <div className={classes.bar}>
      {search && <div className={classes.search}>{search}</div>}
      {filters ? <div className={classes.filters}>{filters}</div> : null}
      {showClear && (
        <button type="button" className={classes.clear} onClick={onClear}>
          Clear
        </button>
      )}
      <div className={classes.spacer} />
      {trailing ? <div className={classes.trailing}>{trailing}</div> : null}
      {total != null && (
        <span className={classes.count}>
          {isNarrowed ? (
            <>
              <span className={classes.countStrong}>{shown.toLocaleString()}</span> of{' '}
              {total.toLocaleString()} {plural}
            </>
          ) : (
            <>
              <span className={classes.countStrong}>{total.toLocaleString()}</span>{' '}
              {total === 1 ? itemNoun : plural}
            </>
          )}
        </span>
      )}
    </div>
  )
}

FilterBar.propTypes = {
  classes: PropTypes.object.isRequired,
  search: PropTypes.node,
  filters: PropTypes.node,
  total: PropTypes.number,
  shown: PropTypes.number,
  itemNoun: PropTypes.string,
  itemNounPlural: PropTypes.string,
  onClear: PropTypes.func,
  trailing: PropTypes.node,
}

export default withStyles(styles)(FilterBar)
